export default __webpack_public_path__ + "static/media/admin.fb8af123.svg";